"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function NeighborhoodCoverage() {
  const { t } = useLanguage();

  const neighborhoods = [
    { name: "Brickell", slug: "brickell" },
    { name: "Aventura", slug: "aventura" },
    { name: "Miami Beach", slug: "miami-beach" },
    { name: "Coral Gables", slug: "coral-gables" },
    { name: "Coconut Grove", slug: "coconut-grove" },
    { name: "Doral", slug: "doral" },
    { name: "Kendall", slug: "kendall" },
    { name: "Pinecrest", slug: "pinecrest" },
    { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
    { name: "Key Biscayne", slug: "key-biscayne" },
    { name: "South Miami", slug: "south-miami" },
    { name: "North Miami Beach", slug: "north-miami-beach" },
  ];

  return (
    <section className="bg-[#fefce8] py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-[28px] font-bold text-[#064e3b] text-center mb-8">
          {t("sliding.neighborhoodH2")}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {neighborhoods.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="inline-flex items-center justify-center bg-[#fefce8] border border-[#064e3b]/20 text-[#064e3b] text-sm font-medium py-2.5 px-4 rounded-[20px] hover:bg-[#047857] hover:text-white transition-colors whitespace-nowrap"
            >
              {n.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}